import React from 'react';
import { SandpackPreview } from '@codesandbox/sandpack-react';

export interface SandboxPreviewProps {
  showRefreshButton?: boolean;
  style?: React.CSSProperties;
}

/**
 * Live preview panel — must be rendered inside a SandboxProvider.
 */
export function SandboxPreview({
  showRefreshButton = false,
  style,
}: SandboxPreviewProps): React.ReactElement {
  return (
    <SandpackPreview
      style={style ?? { height: '100%' }}
      showOpenInCodeSandbox={false}
      showRefreshButton={showRefreshButton}
    />
  );
}
